import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { tributeClient } from '../client/tributeClient';


export type Params = Tributes.GetListParams;

type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useTributes = (params?: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: tributes } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getTributes, params],
    queryFn: () => tributeClient.getTributes(params),
    ...defaultOptions,
    ...options,
  });

  return {
    ...rest,
    tributes,
  };
};
